<template>
  <r-modal
    v-model:isactive="localShow"
    :title="
      isEditMode ? 'Video Referansı Düzenle' : 'Yeni Video Referansı Ekle'
    "
    width="600px"
    :havecontent="true"
    :closeout="false"
  >
    <div style="padding: 16px;">
      <r-flex flx="12" style="margin-bottom: 16px;">
        <div class="field-header">
          <span class="field-icon">🎬</span>
          <span class="helper-text">
            Video Adı (Portaldeki video adını yazınız, örn: Kemiklervideo_01)
          </span>
        </div>
        <r-input
          v-model="form.videoName"
          label="Video Adı *"
          :required="true"
          width="100%"
        />
      </r-flex>

      <r-flex flx="12" style="margin-bottom: 16px;">
        <div class="field-header">
          <span class="field-icon">📚</span>
          <span class="helper-text">
            Bölüm Adı (Örn: Konu eğitimi, Compactus videosu, vb.)
          </span>
        </div>
        <r-input
          v-model="form.sectionName"
          label="Bölüm Adı"
          width="100%"
          placeholder="Örn: Kardiyovasküler Sistem"
        />
      </r-flex>

      <r-flex flx="6" style="margin-right: 8px; margin-bottom: 16px;">
        <div class="field-header">
          <span class="field-icon">⏱</span>
          <span class="helper-text">
            Başlangıç zamanı (sa/dk/sn, örn: 00:05:30)
          </span>
        </div>
        <r-input
          v-model="form.startTime"
          label="Başlangıç Zamanı"
          width="100%"
          placeholder="HH:mm:ss (örn: 00:05:30)"
        />
      </r-flex>

      <r-flex flx="6" style="margin-left: 8px; margin-bottom: 16px;">
        <div class="field-header">
          <span class="field-icon">⏱</span>
          <span class="helper-text">
            Bitiş zamanı (sa/dk/sn, örn: 00:15:45)
          </span>
        </div>
        <r-input
          v-model="form.endTime"
          label="Bitiş Zamanı"
          width="100%"
          placeholder="HH:mm:ss (örn: 00:15:45)"
        />
      </r-flex>

      <r-flex flx="12" style="margin-bottom: 16px;">
        <div class="field-header">
          <span class="field-icon">📝</span>
          <span class="helper-text">Açıklama (Zorunlu)</span>
        </div>
        <r-textarea
          v-model="form.description"
          label="Açıklama *"
          :required="true"
          width="100%"
          :rows="4"
          placeholder="Video hakkında açıklama..."
        />
      </r-flex>
    </div>

    <template v-slot:otherbuttons>
      <r-btn
        bgcolor="#15880d"
        @click="saveVideoReference"
        size="medium"
        :disabled="isSaving || !form.videoName"
      >
        {{ isSaving ? "Kaydediliyor..." : "Kaydet" }}
      </r-btn>
    </template>
  </r-modal>
</template>

<script>
import { ref, watch, computed } from "vue";
import { useStore } from "vuex";

export default {
  name: "VideoReferenceModal",
  props: {
    isactive: {
      type: Boolean,
      default: false
    },
    videoReference: {
      type: Object,
      default: null
    },
    questionId: {
      type: Number,
      required: true
    },
    isEditMode: {
      type: Boolean,
      default: false
    }
  },
  emits: ["update:isactive", "saved"],
  setup(props, { emit }) {
    const store = useStore();
    const isSaving = ref(false);

    const form = ref({
      videoName: "",
      sectionName: "",
      startTime: "",
      endTime: "",
      description: ""
    });

    const localShow = computed({
      get: () => props.isactive,
      set: val => emit("update:isactive", val)
    });

    // Modal açıldığında veya videoReference değiştiğinde form'u doldur
    watch(
      [() => props.isactive, () => props.videoReference],
      ([isActive, videoRef]) => {
        if (isActive) {
          if (props.isEditMode && videoRef) {
            // Düzenleme modu
            form.value = {
              videoName: videoRef.videoName || "",
              sectionName: videoRef.sectionName || "",
              startTime: videoRef.startTime || "",
              endTime: videoRef.endTime || "",
              description: videoRef.description || ""
            };
          } else {
            // Yeni ekleme modu
            form.value = {
              videoName: "",
              sectionName: "",
              startTime: "",
              endTime: "",
              description: ""
            };
          }
        }
      },
      { immediate: true }
    );

    const saveVideoReference = async () => {
      if (isSaving.value) return;
      
      if (!form.value.videoName || !form.value.videoName.trim()) {
        alert("Video adı zorunludur.");
        return;
      }

      if (!form.value.description || !form.value.description.trim()) {
        alert("Lütfen açıklama alanını doldurunuz. Açıklama girmek zorunludur.");
        return;
      }

      try {
        isSaving.value = true;

        const requestData = {
          questionId: props.questionId,
          videoName: form.value.videoName.trim(),
          sectionName: form.value.sectionName?.trim() || null,
          startTime: form.value.startTime?.trim() || null,
          endTime: form.value.endTime?.trim() || null,
          description: form.value.description?.trim() || null
        };

        let res;
        if (props.isEditMode && props.videoReference?.id) {
          // Güncelleme
          res = await store.dispatch("putDatas", {
            api: `VideoReferences/${props.videoReference.id}`,
            data: requestData
          });
        } else {
          // Yeni ekleme
          res = await store.dispatch("postDatas", {
            api: "VideoReferences",
            data: requestData
          });
        }

        if (res && res.result) {
          emit("saved");
          localShow.value = false;
        } else {
          alert("Video referansı kaydedilirken bir hata oluştu.");
        }
      } catch (error) {
        alert("Video referansı kaydedilirken bir hata oluştu.");
      } finally {
        isSaving.value = false;
      }
    };

    return {
      form,
      localShow,
      isSaving,
      saveVideoReference
    };
  }
};
</script>

<style scoped>
.field-header {
  display: flex;
  align-items: center;
  margin-bottom: 6px;
}

.field-icon {
  font-size: 14px;
  margin-right: 6px;
  color: #888;
}

.helper-text {
  font-size: 11px;
  color: #999;
  margin-bottom: 8px;
}
</style>
